import CardBrandIcon from "@/components/pages/AppPages/Dashboard/Wallet/CardBrandIcon";
import { capitalize } from "lodash";
import Stripe from "stripe";

export const PaymentMethodDisplay = ({
  paymentMethod,
}: {
  paymentMethod: Stripe.PaymentMethod;
}) => {
  if (paymentMethod.type === "card") {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <CardBrandIcon
          cardBrand={paymentMethod.card?.brand}
          walletType={paymentMethod.card?.wallet?.type}
          width={40}
          height={40}
        />
        {capitalize(paymentMethod.card?.brand ?? "Card")} ending in{" "}
        {paymentMethod.card?.last4}
      </div>
    );
  } else if (paymentMethod.type === "link") {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <LinkIcon />
        Link
      </div>
    );
  }
  return <div>{capitalize(paymentMethod.type)}</div>;
};

const LinkIcon = () => {
  return (
    <svg
      className="SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--16-svg"
      height={20}
      width={20}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#00D66F" d="M0 0h32v32H0z"></path>
      <path
        fill="#011E0F"
        d="M15.144 6H10c1 4.18 3.923 7.753 7.58 10C13.917 18.246 11 21.82 10 26h5.144c1.275-3.867 4.805-7.227 9.142-7.914v-4.18c-4.344-.68-7.874-4.04-9.142-7.906Z"
      ></path>
    </svg>
  );
};
